import { ROUTES } from '@/shared/lib/constants/routes';
import { Icon } from '@/shared/ui/Icon/Icon';

export interface SidebarMenuItem {
  key: string;
  label: string;
  icon?: React.ReactNode;
  path: string;
  isFixed?: boolean;
}

export const sidebarMenus: SidebarMenuItem[] = [
  {
    key: 'home',
    label: '홈',
    icon: <Icon name="home" width={12} />,
    path: ROUTES.HOME,
  },
  {
    key: 'unified-search',
    label: '데이터 탐색',
    icon: <Icon name="search" width={13} />,
    path: ROUTES.UNIFIED_SEARCH,
  },
  {
    key: 'lineage',
    label: '계보',
    icon: <Icon name="pipeline" width={13.5} />,
    path: ROUTES.LINEAGE,
  },
  {
    key: 'quality',
    label: '데이터 품질',
    icon: <Icon name="shield-check" width={13.5} />,
    path: ROUTES.DATA_QUALITY,
  },
  {
    key: 'domain',
    label: '도메인',
    icon: <Icon name="globe" width={14} />,
    path: ROUTES.DOMAIN,
  },
  {
    key: 'tags',
    label: '태그',
    icon: <Icon name="tag" width={12} />,
    path: ROUTES.TAGS,
  },
  {
    key: 'glossary',
    label: '용어',
    icon: <Icon name="book" width={14} />,
    path: ROUTES.GLOSSARY,
  },
  {
    key: 'experiments',
    label: '실험',
    icon: <Icon name="experiments-nav" width={13} />,
    path: ROUTES.EXPERIMENTS,
  },
];

export const adminSettingsMenu: SidebarMenuItem = {
  key: 'admin-settings',
  label: '관리자 설정',
  icon: <Icon name="setting" width={15} />,
  path: ROUTES.ADMIN_SETTINGS,
  isFixed: true,
};
